import { useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';

import { mutations } from 'RestAPIs/rapini';
import { showSnackbar } from 'components/shared';

import {
  BulkDeletionActionAppointmentRequest,
  EditAppointmentTypeResponse,
  EventResponse
} from 'generated/index';

type UseBulkDeleteAppointmentsParams = {
  onSuccess: () => void;
};

export const useBulkDeleteAppointments = ({
  onSuccess
}: UseBulkDeleteAppointmentsParams) => {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();

  const { mutate, isLoading } = mutations.useAppointmentBulkDeleteAction({
    onSuccess: (data) => {
      queryClient.invalidateQueries('appointmentsOverview');
      onSuccess();

      const succeeded = data?.notifications?.length ?? 0;
      const total = succeeded;

      if (data?.success) {
        showSnackbar({
          severity: 'success',
          message: t('appointmentsOverview.delete.success', { count: total })
        });
      } else {
        showSnackbar({
          severity: 'error',
          message: t('appointmentsOverview.delete.failure')
        });
      }
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('appointmentsOverview.delete.failure')
      });
    }
  });

  const deleteAppointments = (
    appointments: EventResponse[],
    editAppointmentType: EditAppointmentTypeResponse
  ) => {
    const payload: BulkDeletionActionAppointmentRequest = {
      appointmentOccurrenceIdentifiers: appointments.map((appointment) => ({
        entityId: appointment.id,
        originalOccurrenceStart: appointment.date,
        schedulingLabel: 'MRP'
      })),
      editAppointmentType
    };

    mutate(payload);
  };

  return { deleteAppointments, isLoading };
};
